// extracted by mini-css-extract-plugin
export default {"gpa__dark_mode_btn":"DarkModeToggle_gpa__dark_mode_btn__nhsdn"};